import * as angular from "angular";
import {IWindowService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";

export class BillingOrdersDateRangeContext {

  private siteId: string;

  /* @ngInject */
  constructor(private $window: IWindowService, private splitService: SplitService) {
    this.siteId = this.splitService.getSiteId();
  }


  getRange(siteId?) {
    const rangeContext = angular.fromJson(this.$window.localStorage.getItem('billingOrdersDateRangeContext'));
    return rangeContext && rangeContext[siteId || this.siteId] ? rangeContext[siteId || this.siteId] : {};
  }

  setRange(from, to, siteId?) {
    var rangeContext = angular.fromJson(this.$window.localStorage.getItem('billingOrdersDateRangeContext'));

    if (!rangeContext) {
      rangeContext = {};
    }

    rangeContext[siteId || this.siteId] = {from: from, to: to};
    this.$window.localStorage.setItem('billingOrdersDateRangeContext', angular.toJson(rangeContext));
  }
}
angular
  .module('bringoz.admin.billing-accounts')
  .service('billingOrdersDateRangeContext', BillingOrdersDateRangeContext);
